import { memo } from "react";
import type { ReactNode } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export interface SharedHeaderProps {
  logo?: ReactNode;
  title?: string;
  menuOpen: boolean;
  onToggleMenu: (open: boolean) => void;
}

/**
 * Header genérico para layouts autenticados.
 *
 * - Não conhece contexto de usuário, organização ou rotas.
 * - Exibe logo + título e um botão para abrir/fechar o menu lateral em mobile.
 * - Cada aplicação pode trocar por um header próprio caso precise
 *   de informações adicionais.
 */
const SharedHeader = memo<SharedHeaderProps>(
  ({ logo, title, menuOpen, onToggleMenu }) => {
    const handleToggleMenu = () => {
      onToggleMenu(!menuOpen);
    };

    return (
      <AppBar
        position="fixed"
        color="primary"
        sx={(theme) => ({
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="abrir menu"
            onClick={handleToggleMenu}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {logo && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mr: 1.5,
              }}
            >
              {logo}
            </Box>
          )}

          {title && (
            <Typography
              variant="h6"
              component="div"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              {title}
            </Typography>
          )}
        </Toolbar>
      </AppBar>
    );
  }
);

SharedHeader.displayName = "SharedHeader";

export default SharedHeader;

